import React from 'react';
import Card from './../components/Commanbackgroundcard/Card';
import Navbar from '../components/Navbar/Navbar';
import Footer from './../components/Footer/Footer';

// Import all logos
import kawasaki from "../components/Assets/kawasaki.webp";
import lg from "../components/Assets/LG.webp";
import motherson from "../components/Assets/motherson.webp";
import suzuki from "../components/Assets/suzuki.webp";
import mahindra from "../components/Assets/mahindra.webp";
import tata from "../components/Assets/tata-autocomp.webp";
import emerson from "../components/Assets/emerson.webp";
import varroc from "../components/Assets/varroc.webp";
import grupo from "../components/Assets/grupo-antolin.webp";
import iac from "../components/Assets/IAC.webp";
import adt from "../components/Assets/ADT.webp";
import denso from "../components/Assets/denso.webp";
import EKI from "../components/Assets/EKI.webp";
import jabil from "../components/Assets/jabil.webp";
import opw from "../components/Assets/opw.webp";
import PCP from "../components/Assets/PCP.webp";
import plomnium from "../components/Assets/plastic-omnium.webp";
import minda from  "../components/Assets/minda.webp";
import yangeng from "../components/Assets/yangeng.webp";
import yazaki from "../components/Assets/yazaki.webp";

const Clientele = () => {
  const clientLogos = [
    kawasaki,
    lg,
    motherson,
    suzuki,
    mahindra,
    tata,
    emerson,
    varroc,
    grupo,
    iac,
    adt,
    denso,
    EKI,
    jabil,
    opw,
    PCP,
    plomnium,
    minda,
    yangeng,
    yazaki
  ];

  return (
    <div className="min-h-screen relative">
      <Navbar />
      <Card text="OUR VALUABLE CLIENTS" />
      <div className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6 place-items-center">
          {clientLogos.map((logo, index) => (
            <div
              key={index}
              className="p-8 bg-gray-100 shadow-md hover:shadow-xl transition-all duration-300 flex items-center justify-center"
            >
              <img
                src={logo}
                alt={`Client logo ${index + 1}`}
                className="max-h-20 object-contain hover:scale-110 transition-all duration-300"
              />
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Clientele;

